/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { forwardRef } from 'react';

import { Locale, LocaleKeys } from '../../../../core/locale';
import { IViewAllTileProps } from './ContentTile.props';

import './ContentTile.scss';

const ViewAllTile = forwardRef<HTMLDivElement, IViewAllTileProps>(
    ({ isSelected, screenType }, ref): JSX.Element => {
        const containerTypeClass = isSelected
            ? `view-all-container ${screenType?.toLowerCase()} selected`
            : `view-all-container ${screenType?.toLowerCase()}`;

        return (
            <div className={containerTypeClass} ref={ref}>
                <span className="title">{Locale.getString(LocaleKeys.VIEW_ALL_TEXT)}</span>
                <span className="separator"></span>
            </div>
        );
    },
);

export default ViewAllTile;
